export { ResourceDetails } from './ResourceDetails';
